import DocumentsListElement from './DocumentsListElement/index.vue';

export default {
  name: 'DocumentList',
  components: {
    DocumentsListElement,
  },
  props: {
    documentsList: {
      type: Object,
      default: () => [],
    },
  },
  data() {
    return {
      isScrollRight: true,
      isScrollLeft: false,
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes(['documents/getList']);
    },
    documentsSize() {
      if (this.windowWidth > 1700) return 5;
      return 4;
    },
    documentsListCopy() {
      const documentsMap = new Map();

      const sortedDocuments = this.documentsList.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at),
      );

      sortedDocuments.forEach((doc) => {
        const parts = doc.file_name.split('_');
        let shortKey;

        if (parts.length >= 2) {
          shortKey = `${parts[0]}_${parts[1]}`;
        } else {
          shortKey = doc.file_name;
        }

        if (
          !documentsMap.has(shortKey)
          || new Date(doc.created_at) > new Date(documentsMap.get(shortKey).created_at)
        ) {
          documentsMap.set(shortKey, doc);
        }
      });

      const result = Array.from(documentsMap.values()).sort((a, b) => {
        const aAccepted = a.is_accepted === true;
        const bAccepted = b.is_accepted === true;

        if (aAccepted !== bAccepted) {
          return aAccepted ? 1 : -1;
        }

        return 0;
      });

      return result.slice(0, 4);
    },
  },
  mounted() {
    this.checkScroll();
    window.addEventListener('resize', this.handleResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    checkScroll() {
      if (this.$refs.scrollDiv) {
        this.isScrollLeft = true;
        this.isScrollRight = true;
        const div = this.$refs.scrollDiv;
        const maxScrollLeft = div.scrollWidth - div.clientWidth;
        if (div.scrollLeft === 0) {
          this.isScrollLeft = false;
        } else if (div.scrollLeft >= maxScrollLeft) {
          this.isScrollRight = false;
        }
      }
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },
};
